import PdfFileIcon from '@/assets/attachments/pdf_file.svg'
import DocxIcon from '@/assets/attachments/docx.svg'
import TxtIcon from '@/assets/attachments/txt.svg'
import XlsxIcon from '@/assets/attachments/xlsx.svg'
import CsvIcon from '@/assets/attachments/csv.svg'
import JpgIcon from '@/assets/attachments/jpg.svg'
import PngIcon from '@/assets/attachments/png.svg'

const FILE_ICON_MAP: Record<string, string> = {
  pdf: PdfFileIcon,
  docx: DocxIcon,
  txt: TxtIcon,
  xlsx: XlsxIcon,
  csv: CsvIcon,
  jpg: JpgIcon,
  jpeg: JpgIcon,
  png: PngIcon,
}

export function getFileIconSrc(fileExtension: string): string {
  return FILE_ICON_MAP[fileExtension.toLowerCase()] ?? PdfFileIcon
}
